import KozmozAPI from './kozmoz-api';

class  SubscribeForm{

  

      constructor( app, form_id = 'subscribe_form' ){
        this.app = app;
        this.api = new KozmozAPI(app);

        this.form = document.getElementById(form_id);
        this.gui = {}
        this.gui.email      = document.getElementById('mc-email');
        this.gui.fullname   = document.getElementById('mc-fullname');
        this.gui.next       = document.getElementById('mc-next');
        this.gui.response   = document.getElementById('mc-response');
        this.gui.message   = document.getElementById('subscribe_message');
        this.gui.close_btn   = document.getElementById('subscribe_close');
        // this._self = this;
        this.init();


      }

    

      init = () => {
        console.log("initSubcribeForm");
        // let subscribe_btn = document.getElementById('subscribe_btn');
        if(this.gui.next !== null){

          this.gui.next.addEventListener('click', this.subscribeToMailchimp.bind(this));
          // this.gui.close_btn.addEventListener('click', this.closeMessage.bind(this));
        }
      }

      

      subscribeToMailchimp = ( e ) => {
        e.preventDefault();

        console.log('subscribeToMailchimp',this);
        let errors = {}
        if( SubscribeForm.ValidateEmail( this.gui.email.value) ) {
          this.gui.email.classList.add('is-hidden');
          this.gui.fullname.classList.remove('is-hidden');
        }else{
          // invelid mail.
          errors.email = true;
        }


        if( !this.isValid('name', this.gui.fullname.value) ){
          errors.fullname = true;
        }

        console.log(errors.length);

        if(Object.keys(errors).length  == 0){
          let csrf = document.querySelector('#subs_csrf').value;
          let params = {  'email'  : this.gui.email.value, 'fullname' : this.gui.fullname.value, csrf_token: csrf , website : '' };
          //  API REQUEST
          console.log(params);
          // alert("ok")
          this.api.post( this.api.endpoints.subscribe, params, this.onSubscribeResponse, this.onSubscribeResponse );

        }else{
          console.log("erors:",errors)

          // this.form.classList.add('shake');
          this.gui.message.innerHTML = '';
          Object.keys(errors).forEach( (item, i) => {
            console.log("item:", item)
            if(item === 'email'){
              // this.gui[item].classList.add('is-danger');
              setTimeout( this.shake.bind(),100 )
              
              this.gui.message.innerHTML += 'Valid email is required<br>';

              
            }else if(item == 'fullname'){
              
              this.gui.message.innerHTML += 'Your name is required<br>';
            }



          });

              // this.gui.response.classList.remove('is-success');
              // this.gui.response.classList.remove('is-hidden');
        }

      }

      shake = ()=>{
        this.form.classList.add('shake');
        this.form.classList.add('is-danger');
        this.gui.response.classList.remove('is-hidden');
        setTimeout( this.unshake.bind(),3000 )
      }
      unshake = ()=> {
        this.form.classList.remove('shake');
        this.gui.response.classList.add('is-hidden');

      }
      

      onSubscribeResponse = ( e ) =>{ //  xhr
        console.log("onSubscribeResponse",e.target);
        let response = JSON.parse(e.target.response);
        console.log("onSubscribeResponse--->",response.status);
          if (response.status == 200 ) {
              // ADD TO CART SUCCESS !!
              console.log('✓ Success',response);
              console.log('response:', response);

                this.gui.message.innerHTML = response.message;
                this.gui.response.classList.remove('is-hidden');
                this.gui.email.classList.remove('is-danger');
                this.gui.fullname.classList.remove('is-danger');
                this.form.reset();
                // email.value = '';
              // pApp.openModal("Redirecting to cart");
          }
          else{
              console.error('Request failed.  Returned status of ' + response.status);
              this.gui.response.classList.remove('is-success');
              this.gui.message.classList.add('is-danger');
              email.classList.add('is-danger');

              // alert("Something went wrong. Please try again :[")
          }
      }

      
      
      isValid = (type,string) => {
        console.log("isValid:",string)
        if(type == 'name'){
          if(string.length >= 4){
            return true;
          }
          return false;
        }
        return true;
      }
      
      
       closeMessage = (e) =>{
        console.log("closeMessage:",e)
        this.gui.response.classList.add('is-hidden');

       }
      
      onAPIError = () => {
        console.log("onAPIError !");
        alert("API Error. Try again.");

      }

      static ValidateEmail(mail)
      {
       if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
        {
          return (true)
        }
          // alert("You have entered an invalid email address!")
          return (false)
      }



}

export default SubscribeForm
